import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useSelector } from "react-redux";
import DeleteModal from "../../../../common/DeleteModal";
import { Translate } from "../../../../Enums/Tranlate";
import JobTypeService from "../../../../../services/HRM/JobTypeService";

const CardItem = ({ item, setItem, index, setAddModal, setShouldUpdate }) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const Auth = useSelector((state) => state.auth?.auth);
	const lang = useSelector((state) => state.auth?.lang);
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);
	const jobTypeService = new JobTypeService();

	return (
		<tr key={index} className="text-center">
			<td>{item?.name}</td>
			<td>
				{/* {(isExist("edit_job_title") || isExist("delete_job_title")) && ( */}
				<div className="d-flex gap-12">
					<i
						className="la la-edit text-primary fs-24 cursor-pointer"
						onClick={() => {
							setItem(item);
							setAddModal(true);
						}}></i>
					<i
						className="la la-trash text-danger fs-24 cursor-pointer"
						onClick={() => setDeleteModal(true)}></i>
				</div>
				{/* )} */}
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item?.name}
					deletedItem={item}
					modelService={jobTypeService}
					onCloseModal={setDeleteModal}
					setShouldUpdate={setShouldUpdate}
				/>
			)}
		</tr>
	);
};

export default CardItem;
